(function () {
    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

    const fmtMoney = (cents, locale = document.documentElement.lang || 'en', currency = Shopify?.currency?.active || 'USD') => {
        try { return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((cents || 0) / 100); }
        catch { return (cents / 100).toFixed(2); }
    };

    const selectVariantByOptions = (variants, chosen) =>
        variants.find(v =>
            v.option1 === (chosen[0] ?? v.option1) &&
            (v.option2 ?? null) === (chosen[1] ?? (v.option2 ?? null)) &&
            (v.option3 ?? null) === (chosen[2] ?? (v.option3 ?? null))
        ) || variants[0];

    const normalizeId = (x) => String(x);

    const compatiblePlanIdsForVariant = (variant) => {
        const allocs = variant?.selling_plan_allocations || [];
        return new Set(allocs.map(a => normalizeId(a.selling_plan_id)));
    };

    const getFeaturedImageUrl = (wrap) => {
        return wrap?.dataset?.featuredImg || '';
    };

    const getProductTitle = (wrap) => {
        if (wrap?.dataset?.productTitle) return wrap.dataset.productTitle;
        const el = wrap.closest('.product-card')?.querySelector('.product-card__title');
        return el ? el.textContent.trim() : '';
    };

    const ensureModal = () => {
        let modal = document.querySelector('.mini-atc-modal');
        if (!modal) {
            modal = document.createElement('div');
            modal.className = 'mini-atc-modal';
            modal.innerHTML = `
            <div class="mini-atc-modal__sheet">
            <div class="mini-atc-modal__header">
                <button type="button" class="mini-atc-modal__close" aria-label="Close">×</button>
            </div>
            <div class="mini-atc-modal__media"></div>
            <div class="mini-atc-modal__content"></div>
            </div>`;
            document.body.appendChild(modal);

            modal.addEventListener('click', (e) => {
                if (e.target === modal || e.target.closest('.mini-atc-modal__close')) closeModal();
            });
        }
        return modal;
    };

    const openModalWithPanel = (originWrap, variant) => {
        const modal = ensureModal();
        const media = modal.querySelector('.mini-atc-modal__media');
        const content = modal.querySelector('.mini-atc-modal__content');
        const featuredUrl = getFeaturedImageUrl(originWrap);
        const title = getProductTitle(originWrap);

        media.innerHTML = '';
        const img = document.createElement('img');
        img.setAttribute('data-featured-image', '');
        img.alt = title || '';
        img.src = featuredUrl || '';
        media.appendChild(img);

        const titleEl = document.createElement('h3');
        titleEl.className = 'mini-atc-modal__product-title';
        titleEl.textContent = title || '';
        media.appendChild(titleEl);

        const modalWrap = document.createElement('div');
        modalWrap.className = 'mini-atc mini-atc--in-modal';
        modalWrap.dataset.productId = originWrap.dataset.productId;
        modalWrap.dataset.productHandle = originWrap.dataset.productHandle;
        modalWrap.dataset.variants = originWrap.dataset.variants;
        if (originWrap.dataset.spg) modalWrap.dataset.spg = originWrap.dataset.spg;
        if (originWrap.dataset.featuredImg) modalWrap.dataset.featuredImg = originWrap.dataset.featuredImg;
        if (originWrap.dataset.productTitle) modalWrap.dataset.productTitle = originWrap.dataset.productTitle;

        const panelHTML = originWrap.querySelector('.mini-atc__panel').innerHTML;
        const panel = document.createElement('div');
        panel.className = 'mini-atc__panel';
        panel.hidden = false;
        panel.innerHTML = panelHTML;

        modalWrap.appendChild(panel);
        content.innerHTML = '';
        content.appendChild(modalWrap);

        modal.classList.add('is-open');

        updatePrices(modalWrap);

        const spGroups = modalWrap.dataset.spg ? JSON.parse(modalWrap.dataset.spg) : null;
        const tgl = modalWrap.querySelector('.mini-atc__subscribe-toggle');
        const autoLbl = modalWrap.querySelector('.content-auto-label');
        const oneLbl = modalWrap.querySelector('.content-one-label');

        if (tgl && spGroups?.length) {
            tgl.checked = true;
        }

        if (tgl && autoLbl) autoLbl.classList.toggle('active', tgl.checked);
        if (tgl && oneLbl) oneLbl.classList.toggle('active', !tgl.checked);
        showFrequency(modalWrap, !!(tgl && tgl.checked));
        updatePrices(modalWrap);
    };

    const closeModal = () => {
        const modal = document.querySelector('.mini-atc-modal');
        if (modal) modal.classList.remove('is-open');
    };

    const buildPlanOptions = (wrap, spGroups, variant, preferredPlanId = null) => {
        const sel = wrap.querySelector('.mini-atc__frequency-select');
        if (!sel) return null;
        sel.innerHTML = '';
        if (!spGroups?.length) return null;

        const compat = compatiblePlanIdsForVariant(variant);
        const plans = spGroups
            .reduce((plans, group) => plans.concat(group.selling_plans || []), [])
            .filter(p => (compat.size ? compat.has(normalizeId(p.id)) : true));

        plans.forEach(plan => {
            const opt = document.createElement('option');
            opt.value = plan.id;
            opt.textContent = plan.name || (plan.options || []).map(o => o.value).join(' ');
            sel.appendChild(opt);
        });

        let result = null;
        const preferred = preferredPlanId ? normalizeId(preferredPlanId) : null;

        if (preferred && [...sel.options].some(o => normalizeId(o.value) === preferred)) {
            sel.value = preferred;
            result = preferred;
        } else if (compat.size) {
            const firstAlloc = (variant.selling_plan_allocations || [])[0];
            if (firstAlloc && [...sel.options].some(o => normalizeId(o.value) === normalizeId(firstAlloc.selling_plan_id))) {
                sel.value = normalizeId(firstAlloc.selling_plan_id);
                result = normalizeId(firstAlloc.selling_plan_id);
            }
        }

        if (!result && sel.options.length) {
            sel.selectedIndex = 0;
            result = normalizeId(sel.value);
        }
        return result;
    };

    const planPriceForVariant = (variant, planId) => {
        if (!planId) return null;
        const alloc = (variant?.selling_plan_allocations || []).find(a => normalizeId(a.selling_plan_id) === normalizeId(planId));
        return alloc?.price ?? null;
    };

    const ensurePlanOptions = (wrap, spGroups, variant) => {
        const sel = wrap.querySelector('.mini-atc__frequency-select');
        if (!sel) return null;

        const before = sel.value || null;
        const hadOptions = sel.options.length > 0;

        const lastVariantId = wrap.dataset.lastVariantId;
        const variantChanged = String(variant.id) !== String(lastVariantId);
        if (variantChanged) wrap.dataset.lastVariantId = String(variant.id);

        const compat = compatiblePlanIdsForVariant(variant);
        const beforeStillValid = before && (!compat.size || compat.has(normalizeId(before)));

        if (!hadOptions || variantChanged || !beforeStillValid) {
            return buildPlanOptions(wrap, spGroups, variant, beforeStillValid ? before : null);
        }
        return sel.value || null;
    };

    const updatePrices = (wrap) => {
        const variants = JSON.parse(wrap.dataset.variants);
        const spGroups = wrap.dataset.spg ? JSON.parse(wrap.dataset.spg) : null;

        const blocks = [...wrap.querySelectorAll('.mini-atc__option')].sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
        const chosen = blocks.map(b => b.querySelector('.mini-atc__pill.is-active')?.dataset.optionValue || null);
        const variant = selectVariantByOptions(variants, chosen);

        const hiddenId = wrap.querySelector('[data-variant-id]');
        if (hiddenId) hiddenId.value = variant.id;

        const otpSpan = wrap.querySelector('[data-price-otp]');
        const subSpan = wrap.querySelector('[data-price-sub]');
        const addPrice = wrap.querySelector('[data-add-price]');
        if (otpSpan) otpSpan.textContent = fmtMoney(variant.price);

        let planId = null;
        if (spGroups?.length) {
            planId = ensurePlanOptions(wrap, spGroups, variant);
            const p = planPriceForVariant(variant, planId);
            if (subSpan) subSpan.textContent = fmtMoney(p ?? variant.price);
        }

        const subsOn = wrap.querySelector('.mini-atc__subscribe-toggle')?.checked && spGroups?.length;
        let finalPrice = variant.price;
        if (subsOn && planId) {
            const p = planPriceForVariant(variant, planId);
            if (p) finalPrice = p;
        }
        if (addPrice) addPrice.textContent = fmtMoney(finalPrice);
    };

    const showFrequency = (wrap, show) => {
        const freq = wrap.querySelector('.mini-atc__frequency');
        if (freq) freq.hidden = !show;
    };

    const closePanel = (wrap) => {
        const panel = wrap.querySelector('.mini-atc__panel');
        if (panel) panel.hidden = true;
        const openBtn = wrap.querySelector('.mini-atc__open');
        if (openBtn) openBtn.hidden = false;
    };

    const closeAllPanelsExcept = (keepWrap = null) => {
        document.querySelectorAll('.mini-atc').forEach(w => {
            if (keepWrap && w === keepWrap) return;
            closePanel(w);
        });
        closeModal();
    };

    const openInlinePanel = (wrap) => {
        closeAllPanelsExcept(wrap);
        const openBtn = wrap.querySelector('.mini-atc__open');
        if (openBtn) openBtn.hidden = true;
        const panel = wrap.querySelector('.mini-atc__panel');
        if (panel) panel.hidden = false;

        updatePrices(wrap);

        const spGroups = wrap.dataset.spg ? JSON.parse(wrap.dataset.spg) : null;
        const tgl = wrap.querySelector('.mini-atc__subscribe-toggle');
        const autoLbl = wrap.querySelector('.content-auto-label');
        const oneLbl = wrap.querySelector('.content-one-label');

        if (tgl && spGroups?.length) {
            tgl.checked = true;
        }

        if (tgl && autoLbl) autoLbl.classList.toggle('active', tgl.checked);
        if (tgl && oneLbl) oneLbl.classList.toggle('active', !tgl.checked);
        showFrequency(wrap, !!(tgl && tgl.checked));
        updatePrices(wrap);
    };

    const openPanel = (wrap) => {
        const variants = JSON.parse(wrap.dataset.variants);
        const blocks = [...wrap.querySelectorAll('.mini-atc__option')].sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
        const chosen = blocks.map(b => b.querySelector('.mini-atc__pill.is-active')?.dataset.optionValue || null);
        const variant = selectVariantByOptions(variants, chosen);

        if (isMobile()) {
            closeAllPanelsExcept(null);
            openModalWithPanel(wrap, variant);
        } else {
            openInlinePanel(wrap);
        }
    };

    const addToCart = async (wrap) => {
        const id = wrap.querySelector('[data-variant-id]').value;
        const qty = Math.max(1, parseInt(wrap.querySelector('.qty-input').value || '1', 10));
        const payload = { items: [{ id, quantity: qty }] };

        const spGroups = wrap.dataset.spg ? JSON.parse(wrap.dataset.spg) : null;
        if (wrap.querySelector('.mini-atc__subscribe-toggle')?.checked && spGroups?.length) {
            const planId = wrap.querySelector('.mini-atc__frequency-select')?.value;
            if (planId) payload.items[0].selling_plan = planId;
        }

        const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload),
            credentials: 'same-origin'
        });

        if (!res.ok) {
            const t = await res.text().catch(() => '');
            console.error('ATC error', t);
            alert('No se pudo agregar al carrito. Intenta de nuevo.');
            return;
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
        if (wrap.classList.contains('mini-atc--in-modal')) closeModal();
        else closePanel(wrap);
    };

    document.addEventListener('click', (e) => {
        const openBtn = e.target.closest('.mini-atc__open');
        if (openBtn) { e.preventDefault(); openPanel(openBtn.closest('.mini-atc')); return; }

        const cancelBtn = e.target.closest('[data-cancel]');
        if (cancelBtn) {
            e.preventDefault();
            const wrap = cancelBtn.closest('.mini-atc');
            if (wrap.classList.contains('mini-atc--in-modal')) closeModal();
            else closePanel(wrap);
            return;
        }

        const pill = e.target.closest('.mini-atc__pill');
        if (pill) {
            const block = pill.closest('.mini-atc__option');
            block.querySelectorAll('.mini-atc__pill').forEach(p => p.classList.remove('is-active'));
            pill.classList.add('is-active');
            updatePrices(pill.closest('.mini-atc'));
            return;
        }

        const minus = e.target.closest('.qty-btn[data-minus]');
        if (minus) {
            const input = minus.closest('.mini-atc').querySelector('.qty-input');
            input.value = Math.max(1, (parseInt(input.value || '1', 10) - 1)); return;
        }
        const plus = e.target.closest('.qty-btn[data-plus]');
        if (plus) {
            const input = plus.closest('.mini-atc').querySelector('.qty-input');
            input.value = Math.max(1, (parseInt(input.value || '1', 10) + 1)); return;
        }

        const addBtn = e.target.closest('[data-add]');
        if (addBtn) { e.preventDefault(); addToCart(addBtn.closest('.mini-atc')); return; }

        const insidePanel = e.target.closest('.mini-atc__panel');
        const opener = e.target.closest('.mini-atc__open');
        const insideModal = e.target.closest('.mini-atc-modal__sheet');
        if (!insidePanel && !opener && !insideModal) {
            closeAllPanelsExcept(null);
        }
    });

    document.addEventListener('change', (e) => {
        const tgl = e.target.closest('.mini-atc__subscribe-toggle');
        if (tgl) {
            const wrap = tgl.closest('.mini-atc');
            const autoLbl = wrap.querySelector('.content-auto-label');
            const autoLb = wrap.querySelector('.content-one-label');
            if (autoLbl) autoLbl.classList.toggle('active', tgl.checked);
            if (autoLb) autoLb.classList.toggle('active', !tgl.checked);
            showFrequency(wrap, tgl.checked);
            updatePrices(wrap);
            return;
        }

        const freq = e.target.closest('.mini-atc__frequency-select');
        if (freq) { updatePrices(freq.closest('.mini-atc')); }
    });

    window.addEventListener('resize', () => { if (!isMobile()) closeModal(); });
})();
